import {
  HHAlert,
  HHFormControlLabel,
  HHStack,
  HHSwitch,
  HHTypography,
} from '@hinge-health/react-component-library';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDynamicDrawerContext } from '../../context/dynamic-drawer.context';
import { useGetSubscriptionsLazyQuery } from '../../types';
import SubscriptionHolds from './subscription-holds';
import SubscriptionList from './subscription-list';

const UserSubscriptions = ({ userUuid }: { userUuid: string }): JSX.Element => {
  const { onClose } = useDynamicDrawerContext();
  const [searchParams, setSearchParams] = useSearchParams({
    includeVoid: 'false',
  });
  const [getUserSubscriptions, { data, loading, error }] =
    useGetSubscriptionsLazyQuery();
  const includeVoid = searchParams.get('includeVoid') === 'true';

  useEffect(() => {
    getUserSubscriptions({
      variables: { userUuid, includeVoid },
    });
  }, [userUuid, includeVoid, getUserSubscriptions]);

  useEffect(
    () => () => {
      onClose();
    },
    [onClose],
  );

  if (error && !loading) {
    return (
      <HHAlert
        hhVariant="outlined"
        severity="error"
        children={
          <HHTypography hhVariant="body">
            There was an error loading user subscription list
          </HHTypography>
        }
      ></HHAlert>
    );
  }

  return (
    <HHStack flex={1} spacing={8} direction="column" padding={1} paddingTop={4}>
      <HHStack spacing={1}>
        <HHStack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <HHTypography hhVariant="subtitle1">Subscriptions</HHTypography>
          <HHFormControlLabel
            label="Include voids"
            control={
              <HHSwitch
                hhVariant="primary"
                checked={includeVoid}
                onChange={(e): void => {
                  setSearchParams({ includeVoid: e.target.checked.toString() });
                }}
              />
            }
          />
        </HHStack>
        <SubscriptionList
          subscriptionsData={data && data.getSubscriptions}
          loading={loading}
        />
      </HHStack>
      <HHStack spacing={1}>
        <HHStack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <HHTypography hhVariant="subtitle1">Subscription Holds</HHTypography>
        </HHStack>
        <SubscriptionHolds userUuid={userUuid} />
      </HHStack>
    </HHStack>
  );
};

export default UserSubscriptions;
